module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "el-tabs--border-card pb-3 border border-white rounded"
  }, [_c('div', {
    attrs: {
      "id": "loan-list"
    }
  }, [_c('br'), _vm._v(" "), _c('section', [_c('el-tabs', {
    attrs: {
      "active-name": _vm.activeName
    },
    on: {
      "tab-click": _vm.handleClick
    }
  }, _vm._l((_vm.labelName), function(item) {
    return _c('el-tab-pane', {
      key: item.name,
      attrs: {
        "label": item.label,
        "name": item.name,
        "frontApplyState": item.name
      }
    })
  }), 1), _vm._v(" "), _c('router-view')], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-280acaab"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/brokerCenter/MyApplication.vue
// module id = 1945
// module chunks = 5